import * as PropTypes from 'prop-types';
import * as React from 'react';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../shared/url_helpers';

class NewBrandRequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      enabledSaveButton: true,
      errors: [],
      newBrand: props.newBrand || '',
      description: '',
      website: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNewBrandChange = this.handleNewBrandChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleWebsiteChange = this.handleWebsiteChange.bind(this);
  }

  handleNewBrandChange(event) {
    this.setState({
      newBrand: event.target.value,
    });
  }

  handleDescriptionChange(event) {
    this.setState({
      description: event.target.value,
    });
  }

  handleWebsiteChange(event) {
    this.setState({
      website: event.target.value,
    });
  }

  get joinedErrors() {
    return (this.state.errors.join(' '));
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({
      enabledSaveButton: false,
    });

    APIRequest.V3.post(
      UrlHelpers.requestNewBrandPath(),
      {
        new_brand: this.state.newBrand,
        description: this.state.description,
        website: this.state.website,
      },
    )
      .then(() => {
        this.setState({
          errors: [],
        });
        this.props.handleRequestSuccess();
      })
      .fail((response) => {
        this.setState({
          errors: response.responseJSON.errors,
          enabledSaveButton: true,
        });
      });
  }

  hasErrors() {
    return this.state.errors && this.state.errors.length > 0;
  }

  renderErrors() {
    if (!this.hasErrors()) {
      return null;
    }

    const errors = this.state.errors.map((error, index) =>
      (<li key={index}>
        {error}
      </li>));

    return (
      <div
        className="alert alert-error alert-small"
      >
        <p className="mb-half">
          {I18n.t('listingForm.newBrandRequest.errorMsg')}
        </p>
        <ul className="bullets">
          {errors}
        </ul>
      </div>
    );
  }

  renderForm() {
    return (
      <div className="body">
        <h2 className="size-160 mobile-size-130 ptb-1 align-center">
          {I18n.t('listingForm.newBrandRequest.requestABrand')}
        </h2>
        {this.renderErrors()}
        <form className="scaling-plr-1">
          <label>
            {I18n.t('listingForm.newBrandRequest.brandName')}
          </label>
          <input
            type="text"
            className="width-100"
            name="new_brand"
            value={this.state.newBrand}
            onChange={this.handleNewBrandChange}
          />
          <label>
            {I18n.t('listingForm.newBrandRequest.description')}
          </label>
          <textarea
            rows="4"
            className="width-100"
            name="description"
            value={this.state.description}
            onChange={this.handleDescriptionChange}
          />
          <label>
            {I18n.t('listingForm.newBrandRequest.website')}
            <span className="hint">
              &nbsp;{I18n.t('listingForm.newBrandRequest.websiteHint')}
            </span>
          </label>
          <input
            type="text"
            className="width-100"
            name="website"
            value={this.state.website}
            onChange={this.handleWebsiteChange}
          />
          <div className="align-center scaling-ptb-1">
            <button
              className="button button--orange"
              onClick={this.handleSubmit}
              disabled={!this.state.enabledSaveButton}
            >
              {I18n.t('listingForm.newBrandRequest.submit')}
            </button>
          </div>
        </form>
      </div>
    );
  }

  renderRequestSubmitted() {
    return (
      <div className="body">
        <h2 className="size-160 mobile-size-130 ptb-1 align-center color-green">
          <i className="fa fa-check" /> {I18n.t('listingForm.newBrandRequest.gotRequest')}
        </h2>
        <p className="mtb-1 align-center">
          {I18n.t('listingForm.newBrandRequest.expectToHear')}
        </p>
      </div>
    );
  }

  render() {
    if (this.props.requestSuccessfullySubmitted) {
      return this.renderRequestSubmitted();
    }

    return this.renderForm();
  }
}

NewBrandRequestForm.propTypes = {
  newBrand: PropTypes.string,
  handleRequestSuccess: PropTypes.func.isRequired,
  requestSuccessfullySubmitted: PropTypes.bool,
};

NewBrandRequestForm.defaultProps = {
  requestSuccessfullySubmitted: false,
};

export default NewBrandRequestForm;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/new_brand_request_form.jsx